"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMediaQueryStrings = exports.getMediaQueries = exports.deviceBreakpoints = void 0;
var utils_1 = require("./utils");
exports.deviceBreakpoints = [
    { device: 'mobileXs', minWidth: 0, maxWidth: 368 },
    { device: 'mobileSm', minWidth: 369, maxWidth: 599 },
    { device: 'mobileLg', minWidth: 600, maxWidth: 767 },
    { device: 'tabletSm', minWidth: 768, maxWidth: 1023 },
    { device: 'tabletMd', minWidth: 1024, maxWidth: 1231 },
    { device: 'tabletLg', minWidth: 1232, maxWidth: 1439 },
    { device: 'laptopSm', minWidth: 1440, maxWidth: 1679 },
    { device: 'laptopLg', minWidth: 1680, maxWidth: 1919 },
    { device: 'desktopLg', minWidth: 1920, maxWidth: 2040 },
];
var getMediaQueries = function (isSidebarOpen) { return (0, utils_1.getDeviceBreakpoints)(exports.deviceBreakpoints, isSidebarOpen); };
exports.getMediaQueries = getMediaQueries;
var getMediaQueryStrings = function (isSidebarOpen) {
    return (0, utils_1.getStringDeviceBreakpoints)(exports.deviceBreakpoints, isSidebarOpen);
};
exports.getMediaQueryStrings = getMediaQueryStrings;
